var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grow } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import colors from '../../themes/colors';
import { shadows } from '../../themes/legacy/theme';
import textDefinitions from '../../themes/textDefinitions';
import { getBannerColors } from '../../utils/banner/getBannerColors';
var ToasterProvider = function (_a) {
    var children = _a.children;
    return (_jsx(SnackbarProvider
    // this is part of the notistack library but for some reason is not available in the typedef
    // @ts-ignore
    , __assign({ 
        // this is part of the notistack library but for some reason is not available in the typedef
        // @ts-ignore
        sx: {
            '& .SnackbarContent-root': {
                minWidth: 'unset !important',
                borderWidth: 2,
                borderStyle: 'solid',
                borderRadius: '8px'
            },
            '& .SnackbarItem-contentRoot': {
                boxShadow: shadows["default"],
                justifyContent: 'center'
            },
            // Colors
            '& .SnackbarItem-message': __assign({ color: colors.neutral100 }, textDefinitions.body2),
            '& .SnackbarItem-variantInfo': __assign({}, getBannerColors('info')),
            '& .SnackbarItem-variantWarning': __assign({}, getBannerColors('warning')),
            '& .SnackbarItem-variantError': __assign({}, getBannerColors('error')),
            '& .SnackbarItem-variantSuccess': __assign({}, getBannerColors('success'))
        }, color: "neutral100", dense: true, preventDuplicate: true, hideIconVariant: true, TransitionComponent: Grow, anchorOrigin: { horizontal: 'center', vertical: 'bottom' }, maxSnack: 3 }, { children: children })));
};
export default ToasterProvider;
